export const customSort = (a, b) => {
    const topCities = [
        "北京",
        "上海",
        "广州",
        "深圳",
        "成都",
        "重庆",
        "杭州",
        "武汉",
        "南京",
        "天津",
        "青岛",
        "长沙",
        "东莞",
        "西安",
        "郑州",
        "济南",
        "哈尔滨",
        "沈阳",
        "长春",
        "大连",
        "厦门",
        "福州",
        "佛山",
        "无锡",
        "宁波",
        "佛山",
        
    ]

    const aIndex = topCities.indexOf(a.city)
    const bIndex = topCities.indexOf(b.city)
    return aIndex - bIndex
}

